// extracted by mini-css-extract-plugin
export default {"PaperContainer":"Paper_PaperContainer__MKoBQ"};